import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { map } from 'rxjs/operators';
import { FilterData } from '../../components/filtro/filtro.component';

@Injectable()
export class RankingCboConsultasService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getAnoBase(regans: string) {
    return this.simuladorGoApi.fetchAnosBases(regans);
  }

  getUnidadesOperadora(regans: string) {
    return this.simuladorGoApi.fetchUnidadesOperadora(regans).pipe(map(data => data.items));
  }

  getData(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    ano_realizacao: number,
    id_faixa_etaria_consulta: number,
    filtros: FilterData,
    cdUnidadeList?: string,
  ) {
    return this.simuladorGoApi
      .fetchRankingCbosConsultasEletivas({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        ano_realizacao,
        id_faixa_etaria_consulta,
        cd_unidade_list: cdUnidadeList,
        ...filtros,
      })
      .pipe(map(data => data.items));
  }
}
